import { useContext, useEffect, useState } from 'react';
import { useLoaderData, useLocation, useNavigate } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import PageBuilder from '../../../../library/Builders/PageBuilder/PageBuilder';
import { GlobalContext } from '../../../../library/Core/GlobalContext';
import { SmartContext } from '../../../../library/Core/SmartContext';
import smartReducer from '../../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import { addUserSpecificDomains } from '../../../../library/Service/domainService';
import { handleCompleteLater, handleNext, onCurrentJobSelectionChange } from './TeachingJobActions';
import { onPrimaryCurrentChange } from '../primaryCurrentJob';
import TeachingJobLayout from './TeachingJobLayout';
import ProfilePicturePageConfig from '../ProfilePicturePageConfig.json';
import CurrentJobInformationLayout from '../CurrentJobInformationLayout';

const TeachingJob = () => {
    const { globalState } = useContext(GlobalContext);
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState('');

    const location = useLocation();
    const currentMatch = location.pathname.includes('current')

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {
            NEXT: handleNext,
            I_LL_DO_THIS_LATER: handleCompleteLater,
            ROUTER_NAVIGATE: navigate,
            isCurrent: onCurrentJobSelectionChange,
            isPrimaryCurrent: onPrimaryCurrentChange('teachingWork'),
            // startDate : onStartDateChange,
            REDIRECT: setRedirectUrl,
        },
    } as any);

    const { formConfig, data, routeInfo } = useLoaderData() as State;

    useEffect(() => {
        const domain = addUserSpecificDomains(new Map([...globalState.domain]),data);

        domain.set('JOB_SENIORITY_LEVEL', [
            { categoryCode: 'JOB_SENIORITY_LEVEL', code: 'Research Assistant', value: 'Research Assistant', parentCode: '', displayOrder: 1 },
            { categoryCode: 'JOB_SENIORITY_LEVEL', code: 'Faculty Member', value: 'Faculty Member', parentCode: '', displayOrder: 2 },
            { categoryCode: 'JOB_SENIORITY_LEVEL', code: 'Head of Department', value: 'Head of Department', parentCode: '', displayOrder: 3 },
            { categoryCode: 'JOB_SENIORITY_LEVEL', code: 'Head of Institution', value: 'Head of Institution', parentCode: '', displayOrder: 4 },
        ]);

        // data['teachingWork'] = data['teachingWork'] ?? {};

        const jobRoleCodeDomain = domain.get('JOB_ROLE_CODE');
        if (jobRoleCodeDomain) {
            domain.set(
                'JOB_ROLE_CODE',
                jobRoleCodeDomain.filter((role) => role.code !== 'FREELANCER')
            );
        }

        const typeOfInstituteCodeDomain = domain.get('INSTITUTE_TYPE_CODE');
        if (typeOfInstituteCodeDomain) {
            domain.set(
                'INSTITUTE_TYPE_CODE',
                typeOfInstituteCodeDomain.filter(
                    (role) =>
                        role.code !== 'UNIVERSITY' &&
                        role.code !== 'UPSKILLING_INSTITUTE' &&
                        role.code !== 'JOB_CONSULTANCY'
                )
            );
        }

        // This code for Profile Picture Section from config----------
            let updatedFormConfig: any = { ...formConfig };
            console.log("currentMatch",currentMatch)
            if (currentMatch) {
                const rawProfileSection =
                    ProfilePicturePageConfig.sectionRepository.find(
                        (sec: any) => sec.id === "profile"
                    );
                console.log("rawProfileSection",rawProfileSection)
                if (rawProfileSection && !updatedFormConfig.sections?.includes("profile")) {
                    updatedFormConfig = {
                        ...updatedFormConfig,
                        sections: [...(updatedFormConfig.sections ?? []), "profile"],
                        sectionRepository: [
                            ...(updatedFormConfig.sectionRepository ?? []),
                            rawProfileSection as any
                        ],
                    };
                }
            }
            // end here

        // dispatch({
        //     type: 'DATA_INIT',
        //     payload: {formConfig: updatedFormConfig,data,domain,routeInfo},
        // });

        const updatedTeachingWork = (data?.teachingWork?.length
            ? data.teachingWork
            : [{}]
        ).map((job: any) => ({
            ...job,
            isCurrent: currentMatch ?  true : job?.isCurrent ?? 0
        }));

        dispatch({
            type: 'DATA_INIT',
            payload: {
                formConfig: updatedFormConfig,
                data: {
                    ...data,
                    teachingWork: updatedTeachingWork,
                    currentMatch
                },
                domain,
                routeInfo,
            },
        });
    }, []);

    // useEffect(() => {
    //     const domain = addUserSpecificDomains(new Map([...globalState.domain]), data);

    //     const seniorityLevel = [
    //         {
    //             categoryCode: 'JOB_SENIORITY_LEVEL', // replace with your actual categoryCode
    //             code: 'Research Assistant', // replace with desired year
    //             value: 'Research Assistant', // replace with desired value
    //             parentCode: '',
    //             displayOrder: 1, // replace with the appropriate order
    //         },
    //         {
    //             categoryCode: 'JOB_SENIORITY_LEVEL',
    //             code: 'Faculty Member',
    //             value: 'Faculty Member',
    //             parentCode: '',
    //             displayOrder: 2,
    //         },
    //         {
    //             categoryCode: 'JOB_SENIORITY_LEVEL',
    //             code: 'Head of Department',
    //             value: 'Head of Department',
    //             parentCode: '',
    //             displayOrder: 3,
    //         },
    //         {
    //             categoryCode: 'JOB_SENIORITY_LEVEL',
    //             code: 'Head of Institution',
    //             value: 'Head of Institution',
    //             parentCode: '',
    //             displayOrder: 4,
    //         },
    //     ];

    //     console.log(domain);
    //     domain.set('JOB_SENIORITY_LEVEL', seniorityLevel);
    //     data['teachingWork'] = data['teachingWork'] ?? {};

    //     const jobRoleCodeDomain = domain.get('JOB_ROLE_CODE');
    //     if (jobRoleCodeDomain) {
    //         const filteredJobRoleCode = jobRoleCodeDomain.filter((role) => role.code !== 'FREELANCER');
    //         domain.set('JOB_ROLE_CODE', filteredJobRoleCode);
    //     }

    //     const typeOfInstituteCodeDomain = domain.get('INSTITUTE_TYPE_CODE');
    //     if (typeOfInstituteCodeDomain) {
    //         const filteredInstituteCode = typeOfInstituteCodeDomain.filter((role) =>  
    //             role.code !== 'UNIVERSITY' && role.code !== 'UPSKILLING_INSTITUTE' && role.code !== 'JOB_CONSULTANCY'
    //         );
    //         domain.set('INSTITUTE_TYPE_CODE', filteredInstituteCode);
    //     }

    //     dispatch({
    //         type: 'DATA_INIT',
    //         payload: { formConfig, data, domain, routeInfo },
    //     });
    // }, []);

    useEffect(() => {
        if (redirectUrl !== '') {
            navigate(redirectUrl);
        }
    }, [redirectUrl]);

    let message = (currentMatch) ? `Since you mentioned you are currently Working for an Educational Institute, please provide the details.` :
    `In your work status, you mentioned that you are currently working for an educational institute. Please provide the details of your work.`

    const LayoutComponent = currentMatch ? CurrentJobInformationLayout : TeachingJobLayout;

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
             <LayoutComponent> {!state.flags.isDataLoading && <PageBuilder data={message} />}</LayoutComponent>
            {/* <TeachingJobLayout>{!state.flags.isDataLoading && <PageBuilder data={message}/>}</TeachingJobLayout> */}
        </SmartContext.Provider>
    );
};

export default TeachingJob;
